module.exports = __webpack_public_path__ + "img/不通过.c50041ef.svg";